import React from 'react';

import { MenuItem } from '@mui/material';

import { AppInput, type AppInputProps } from './app-input';
import { AppInputBase } from './app-input-base';

//
//

type Option = {
  value: string;
  label?: string;
  disabled?: boolean;
};

export type AppSelectProps = AppInputProps & {
  options?: Option[];
  id?: string;
  children?: React.ReactNode;
  isForm?: boolean;
  renderValue?: any;
};

export const AppSelect: React.FC<AppSelectProps> = ({
  name,
  label,
  options,
  helperText,
  placeholder,
  id,
  isForm,
  children,
  defaultValue,
  ...props
}) => {
  const Input = isForm ? AppInput : AppInputBase;

  //

  return (
    <Input
      select
      id={id || name}
      name={name}
      label={label}
      helperText={helperText}
      defaultValue={defaultValue ? defaultValue : ''}
      {...props}
      onChange={(event) => {
        props?.onChange?.(event);
      }}
    >
      {children ||
        options?.map((option) => (
          <MenuItem disabled={option.disabled} key={option.value} value={option.value}>
            {option.label || option.value}
          </MenuItem>
        ))}
    </Input>
  );
};
